import {Inject, Injectable} from '@angular/core';
import {EntityService} from "@shared/services/entity.service";
import {EntityFeatureNameEnum} from "@shared/contracts/entity-store.contract";
import {AddressTypeType} from "@generated/graphql";
import {AddressType} from "@modules/address/models/address-type.model";
import {addressTypeFactory, AddressTypeFactory} from "@modules/address/factories/address-type.factory";
import {Store} from "@ngrx/store";
import {ADDRESS_TYPE_STORE, AddressTypeStore} from "@modules/address/store/address-type.store";

@Injectable({
  providedIn: 'root',
})
export class AddressTypeService extends EntityService<EntityFeatureNameEnum.AddressType, AddressTypeType, AddressType> {
  constructor(
    protected readonly store: Store,
    @Inject(ADDRESS_TYPE_STORE) protected readonly entityStore: AddressTypeStore,
  ) {
    super(store, entityStore);
  }


  get factory(): AddressTypeFactory {
    return addressTypeFactory;
  }
}
